import { render, staticRenderFns } from "./SelectTheme.vue?vue&type=template&id=383ff82d&"
import script from "./SelectTheme.vue?vue&type=script&lang=ts&"
export * from "./SelectTheme.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports